import banks from '@assets/constants/banks';

const getBankName = (bic: any): any => {
  const bankBicObj = banks.find(item => item.bank_code === bic);
  return bankBicObj?.bank_name;
};

export default getBankName;
